export { default } from "./buildRecentListingsImpressionLabel";
